import React, { useContext } from 'react';
import { Col, Modal, Row, Button, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { ProductContext } from 'context/Context';
import { changeToCoin } from 'helpers/utils';
// import { useAppContext } from 'Main';

const CartModal = () => {
 const {
  productsState: {
   cartModal: { show, product, type, quantity }
  },
  productsDispatch
 } = useContext(ProductContext);

 /* const {
  config: { isDark }
 } = useAppContext(); */

 const handleClose = () => {
  productsDispatch({
   type: 'TOGGLE_CART_MODAL'
  });
 };

 if (!product?._id) return <></>;

 return (
  <Modal show={show} onHide={handleClose} size="lg">
   {/* <Modal.Header closeButton closeVariant={isDark ? 'white' : null} className="border-200"> */}
   <Modal.Header closeButton closeVariant={null} className="border-200">
    <Modal.Title as="h5">
     <Flex alignItems="center">
      <div className="icon-item bg-success-subtle shadow-none">
       <FontAwesomeIcon icon="cart-plus" className="text-success" />
      </div>
      <div className="ms-2">
       Acabas de {type === 'remove' ? 'remover' : 'agregar'} {quantity} elemento
       {quantity === 1 ? '' : 's'}
      </div>
     </Flex>
    </Modal.Title>
   </Modal.Header>
   <Modal.Body>
    <Row className="g-0 align-items-center">
     <Col>
      <Flex alignItems="center">
       <Link to={`/product/details/${product?._id}`}>
        <Image
         src={
          product?.references?.reduce((acc, e) => {
           if (e.images.length) acc = e.images[0];
           return acc;
          }, '') || product?.image[0]
         }
         rounded
         className="me-3 d-none d-md-block"
         width="80"
         alt="product image"
        />
       </Link>
       <div className="flex-1">
        <h5 className="fs-9">
         <Link to={`/product/details/${product?._id}`} className="text-900">
          {product?.name}
         </Link>
        </h5>

        <div className="fs--1 fs-md-0 d-flex">
         {product.references.map((e, i) => (
          <Flex key={i} className="flex-fill" alignItems="center" wrap="nowrap" justifyContent="start">
           <span className="me-3">{e.ref}: </span>
           {e?.color ? <FontAwesomeIcon icon="circle" className="" transform="shrink-3" style={{ color: e.color }} /> : <></>}
           <span className="">{e.name.toLowerCase()}</span>
          </Flex>
         ))}
        </div>
       </div>
      </Flex>
     </Col>
     <Col sm="auto" className="ps-sm-3 d-none d-sm-block">
      {changeToCoin({ amount: product?.totalPrice, symbol: true, cents: true })}
     </Col>
    </Row>
   </Modal.Body>
   {type !== 'remove' && (
    <Modal.Footer className="border-200">
     <Button to="/e-commerce/checkout" as={Link} size="sm" onClick={handleClose} variant="secondary">
      Checkout
     </Button>
     <IconButton
      as={Link}
      to="/shopping-cart"
      size="sm"
      className="ms-2"
      icon="chevron-right"
      variant="primary"
      iconAlign="right"
      onClick={handleClose}
     >
      Ir al carrito
     </IconButton>
    </Modal.Footer>
   )}
  </Modal>
 );
};

export default CartModal;
